import Vue from "vue";

export const appConfig = "main";
export const appMapSuffix = "_main";
export const theme = "main";
export const ActionType = [
  {
    value: "NONE",
    label: "None"
  },
  {
    value: "CLOSE_FIRST_SCREEN",
    label: "Close first screen"
  },
  {
    value: "CLOSE_SCREEN",
    label: "Close screen"
  },
  {
    value: "EXIT_APP",
    label: "Exit app"
  },
  {
    value: "PLAY_YOUTUBE",
    label: "Play youtube"
  },
  {
    value: "LAUNCH_URL",
    label: "Launch url"
  },
  {
    value: "OPEN_PAGE",
    label: "Open page"
  },
  {
    value: "OPEN_SCANNER",
    label: "Open scanner"
  },
  {
    value: "OPEN_BROWSER",
    label: "Open browser"
  },
  {
    value: "LOGIN",
    label: "Login"
  },
  {
    value: "LOGOUT",
    label: "Logout"
  },
  {
    value: "SHOW_CHANNELS",
    label: "Show channels"
  },
  {
    value: "POST",
    label: "Post"
  },
  {
    value: "SHOW_MESSAGE",
    label: "Show message"
  }
];
export const CachingType = [
  {
    value: "NEVER",
    label: "Never"
  },
  {
    value: "ON_OPEN",
    label: "On open"
  },
  {
    value: "ALWAYS",
    label: "Always"
  }
];
export const ConditionType = ["TRUE", "FALSE", "LOGGED_IN", "LOGGED_OUT"];
export const ConnectorType = [
  "REST",
  "FIREBASE_FIRESTORE",
  "FIREBASE_REALTIME_DATABASE",
  "FIREBASE_STORAGE"
];

const widgetsDataDefaults = {
  text: {
    value: null
  },
  button: {
    actionItem: {
      action: {
        type: "NONE"
      },
      icon: null,
      text: null,
      showCondition: null
    }
  },
  image: {
    src: null
  },
  link: {
    href: null
  },
  separator: {
    showDivider: false,
    height: 20
  }
};
export const ContentType = [
  {
    value: "H1",
    label: "Heading 1",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "H2",
    label: "Heading 2",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "H3",
    label: "Heading 3",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "H4",
    label: "Heading 4",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "H5",
    label: "Heading 5",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "H6",
    label: "Heading 6",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "TITLE",
    label: "Title",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "SUBTITLE",
    label: "Subtitle",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "HEADLINE",
    label: "Headline",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "SUBHEAD",
    label: "Subhead",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "OVERLINE",
    label: "Overline",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "BODY1",
    label: "Body 1",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "BODY2",
    label: "Body 2",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "CAPTION",
    label: "Caption",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "DISPLAY1",
    label: "Display 1",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "DISPLAY2",
    label: "Display 2",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "DISPLAY3",
    label: "Display 3",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "DISPLAY4",
    label: "Display 4",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "P",
    label: "Paragraph",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "A",
    label: "Link",
    data: {
      ...widgetsDataDefaults.link
    }
  },
  {
    value: "Q",
    label: "Quote",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "YOUTUBE",
    label: "YouTube",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "HTML",
    label: "Html",
    data: {
      ...widgetsDataDefaults.text
    }
  },
  {
    value: "SEP",
    label: "Separator",
    data: {
      ...widgetsDataDefaults.separator
    }
  },
  {
    value: "BUTTON",
    label: "Button",
    data: {
      ...widgetsDataDefaults.button
    }
  },
  {
    value: "IMG",
    label: "Image",
    data: {
      ...widgetsDataDefaults.image
    }
  },
  {
    value: "WEBVIEW",
    label: "Webview",
    data: {
      ...widgetsDataDefaults.image
    }
  }
];
export const EntityType = [
  "APP_CONFIG",
  "APP_MAP",
  "CARD_ITEM",
  "CARD_PAGE",
  "CONTENT_PAGE",
  "DETAILS_PAGE",
  "LIST_ITEM",
  "LIST_PAGE",
  "SIDE_MENU",
  "SLIDE_PAGE",
  "THEME",
  "WEB_LINK",
  "YOUTUBE_LINK",
  "TEL_LINK",
  "CLOUD_FUNCTION"
];

export const eventHub = new Vue({
  data: () => ({
    user: null
  })
});

export const FloatingType = [
  "CENTER_DOCKED",
  "CENTER_FLOAT",
  "MINI_START_TOP",
  "START_TOP",
  "END_FLOAT",
  "END_TOP",
  "END_DOCKED"
];
